export const BALL = "ball"
export const SPRITE = "sprite"
export const CAR_SUFFIX = "-car"
export const GROUP_SUFFIX = "-group"

export const BLUE_GOAL_CAMERA = "Blue Goal Camera"
export const ORANGE_GOAL_CAMERA = "Orange Goal Camera"
export const ABOVE_FIELD_CAMERA = "Above Field Camera"
export const FREE_CAMERA = "Free Camera"
export const ORTHOGRAPHIC = {
  ABOVE_FIELD: "ORTHOGRAPHIC_ABOVE_FIELD",
  BLUE_LEFT: "ORTHOGRAPHIC_BLUE_LEFT",
  BLUE_RIGHT: "ORTHOGRAPHIC_BLUE_RIGHT",
  ORANGE_LEFT: "ORTHOGRAPHIC_ORANGE_LEFT",
  ORANGE_RIGHT: "ORTHOGRAPHIC_ORANGE_RIGHT",
}
